// extracted by mini-css-extract-plugin
module.exports = {"tokenUpchargeDisclaimer":"index__tokenUpchargeDisclaimer__1M8N0"};